export default __webpack_public_path__ + "static/media/i_bus-gen_gy.d225665f.svg";